import Route from 'mewe/routes/route';

export default Route.extend({

  redirect(redir) {
    this.replaceWith('/cms/about');
  }

});
